module.exports = __webpack_public_path__ + "img/game4.a04ee5c7.png";